<template>
	<div>
		<UserComplianceConsentAcceptance v-if="showAcceptanceModal" />

		<NewProjectModal />
		<EditProjectModal v-if="this.$store.projectsStore.state.editProjectModal" />
		<DashboardWeeklyModal v-if="this.$store.consultasStore.state.weeklyDashboardModal" />
		<DashboardRDIWeeklyModal v-if="this.$store.rdiStore.state.weeklyDashboardModal" />
		<EditUserModal v-if="this.$store.usersStore.state.selectedUserInfo && this.$store.usersStore.state.editUserModal" />
		<EditPermisosUserModal v-if="this.$store.usersStore.state.selectedUserInfo && this.$store.usersStore.state.editPermisosUserModal" />
		<EditPermisosEmpresaUserModal v-if="this.$store.usersStore.state.selectedUserInfo && this.$store.usersStore.state.editPermisosEmpresaUserModal" />
		<EditUserProjectsModal v-if="this.$store.usersStore.state.selectedUserInfo && this.$store.usersStore.state.editUserProjectsModal" />
		<NewCompanyModal />
		<NewUserModal v-if="this.$store.usersStore.state.newUserModal"/>
		<AddPlanoModal v-if="this.$store.entregaStore.state.addPlanoModal"  :modalStatus="this.$store.entregaStore.state.addPlanoModal" :closeModal="() => this.$store.entregaStore.commit('setAddPlanoModal', false)"/>
		<CreateProtocoloModal v-if="this.$store.entregaStore.state.createProtocoloModal"  :modalStatus="this.$store.entregaStore.state.createProtocoloModal" :closeModal="() => this.$store.entregaStore.commit('setCreateProtocoloModal', false)"/>
		<EditPlanoModal v-if="this.$store.entregaStore.state.editPlanoModal"  :modalStatus="this.$store.entregaStore.state.editPlanoModal" :closeModal="() => this.$store.entregaStore.commit('setEditPlanoModal', false)"/>
		<PlanoTotalViewer v-if="this.$store.entregaStore.state.planoTotalViewerModal" />

		<CreateTareaModal v-if="this.$store.consultasStore.state.createTareaModal" :modalStatus="this.$store.consultasStore.state.createTareaModal" :closeModal="() => this.$store.consultasStore.commit('setCreateTareaModal', false)" :draftToLoad="this.$store.consultasStore.state.draftToLoad"/>
		<CreateRDIModal v-if="this.$store.rdiStore.state.createRDIModal" :modalStatus="this.$store.rdiStore.state.createRDIModal" :closeModal="() => this.$store.rdiStore.commit('setCreateRDIModal', false)" :draftToLoad="this.$store.rdiStore.state.draftToLoad"/>
		<CreateAdicionalModal v-if="this.$store.adicionalesStore.state.createAdicionalModal" :modalStatus="this.$store.adicionalesStore.state.createAdicionalModal" :closeModal="() => this.$store.adicionalesStore.commit('setCreateAdicionalModal', false)" :draftToLoad="this.$store.adicionalesStore.state.draftToLoad"/>
		<CreateEntregaModal v-if="this.$store.entregaStore.state.createEntregaModal" :modalStatus="this.$store.entregaStore.state.createEntregaModal" :closeModal="() => this.$store.entregaStore.commit('setCreateEntregaModal', false)" :draftToLoad="this.$store.entregaStore.state.draftToLoad"/>
		<CreateMeetingModal v-if="this.$store.meetingStore.state.createMeetingModal" :modalStatus="this.$store.meetingStore.state.createMeetingModal" :closeModal="() => this.$store.meetingStore.commit('setCreateMeetingModal', false)" :draftToLoad="this.$store.meetingStore.state.draftToLoad"/>
				<CreateCommunicationFolioModal v-if="this.$store.communicationBooksStore.state.createFolioModal" :modalStatus="this.$store.communicationBooksStore.state.createFolioModal" :draftToLoad="this.$store.communicationBooksStore.state.draftToLoad" :closeModal="() => this.$store.communicationBooksStore.commit('setCreateFolioModal', false)"/>
				<CreateCommunicationFolioOpeningModal v-if="this.$store.communicationBooksStore.state.createOpeningFolioModal" :modalStatus="this.$store.communicationBooksStore.state.createOpeningFolioModal" :closeModal="() => this.$store.communicationBooksStore.commit('setCreateOpeningFolioModal', false)"/>
		<MeetingModal v-if="this.$store.meetingStore.state.currentMeeting" />
				<CommunicationFolioModal v-if="this.$store.communicationBooksStore.state.currentFolio" />
		<EntregaConfigModal v-if="this.$store.entregaStore.state.entregaConfigModal" :modalStatus="this.$store.entregaStore.state.entregaConfigModal" :closeModal="() => this.$store.entregaStore.commit('setEntregaConfigModal', false)"   />
		<CreateAdicionalLikelyModal v-if="this.$store.adicionalesStore.state.createPosibleAdicionalModal" :modalStatus="this.$store.adicionalesStore.state.createPosibleAdicionalModal" :closeModal="() => this.$store.adicionalesStore.commit('setCreatePosibleAdicionalModal', false)" :draftToLoad="this.$store.adicionalesStore.state.draftToLoad"/>
			
		<AdicionalLikelyModal v-if="isAdditionalLikely"/>
		<TareaModal v-else-if="isTask && checkPermissions(['view_tasks_listing'])"/>

		<EntregaModal v-if="this.$store.entregaStore.state.currentEntrega"/>
		<RDIModal v-if="this.$store.rdiStore.state.currentRDI && checkPermissions(['view_rdi'])"/>
		<AdicionalModal v-if="this.$store.adicionalesStore.state.currentAdicional && checkPermissions(['view_additionals'])" />
		<AcceptCancelModal />
		<CloseOpenProjectModal v-if="this.$store.projectsStore.state.closeOpenProjectModal" :closeOpenProjectModal="this.$store.projectsStore.state.closeOpenProjectModal"/>
		<NotificationsConfigModal v-if="this.$store.usersStore.state.notificationsConfigModal" :modalStatus="this.$store.usersStore.state.notificationsConfigModal" :closeModal="() => this.$store.usersStore.commit('setNotificationsConfigModal', false)"/>
		<SpecialtySubscriptionModal v-if="this.$store.usersStore.state.specialtySubscriptionModal" :modalStatus="this.$store.usersStore.state.specialtySubscriptionModal" :closeModal="() => this.$store.usersStore.commit('setSpecialtySubscriptionModal', false)"/>
		<ComplaintModal v-model="complaintModal" />
		<CommunicationModal v-model="communicationModal" />
	</div>
</template>

<script>
import UserComplianceConsentAcceptance from './Users/UserComplianceConsentAcceptance'
import NewProjectModal from './Projects/NewProjectModal'
import EditProjectModal from './Projects/EditProjectModal'
import DashboardWeeklyModal from './Projects/DashboardWeeklyModal'
import DashboardRDIWeeklyModal from './Projects/DashboardRDIWeeklyModal'
import NewCompanyModal from './Projects/NewCompanyModal'
import CloseOpenProjectModal from './Projects/CloseOpenProjectModal'
import NewUserModal from './Users/NewUserModal'
import EditUserModal from './Users/EditUserModal'
import EditPermisosUserModal from './Users/EditPermisosUserModal'
import EditPermisosEmpresaUserModal from './Users/EditPermisosEmpresaUserModal'
import EditUserProjectsModal from './Users/EditUserProjectsModal'
import CreateTareaModal from './Tasks/CreateTareaModal'
import TareaModal from './Tasks/TareaModal'
import CreateRDIModal from './Rdis/CreateRDIModal'
import RDIModal from './Rdis/RDIModal'
import CreateEntregaModal from './Entrega/CreateEntregaModal'
import EntregaConfigModal from './Entrega/EntregaConfigModal'
import EntregaModal from './Entrega/EntregaModal'
import AddPlanoModal from './Entrega/AddPlanoModal'
import CreateProtocoloModal from './Entrega/CreateProtocoloModal'
import EditPlanoModal from './Entrega/EditPlanoModal'
import PlanoTotalViewer from './Entrega/PlanoTotalViewer'
import CreateAdicionalModal from './Adicionales/CreateAdicionalModal'
import CreateAdicionalLikelyModal from './Adicionales/CreateAdicionalLikelyModal'
import AdicionalLikelyModal from './Adicionales/AdicionalLikelyModal'
import AdicionalModal from './Adicionales/AdicionalModal'
import AcceptCancelModal from './General/AcceptCancelModal'
import NotificationsConfigModal from './Users/NotificationsConfigModal'
import SpecialtySubscriptionModal from './Users/SpecialtySubscriptionModal'
import CreateMeetingModal from './Meetings/CreateMeetingModal'
import MeetingModal from './Meetings/MeetingModal'
import ComplaintModal from './General/ComplaintModal'
import CommunicationModal from './General/CommunicationModal'
import CreateCommunicationFolioModal from './Communications/CreateCommunicationFolioModal'
import CreateCommunicationFolioOpeningModal from './Communications/CreateCommunicationFolioOpeningModal'
import CommunicationFolioModal from './Communications/CommunicationFolioModal'

export default {
	name: 'GlobalModalsIndex',
	components: {
		NewProjectModal, EditProjectModal, DashboardWeeklyModal, DashboardRDIWeeklyModal, NewCompanyModal, NewUserModal, EditUserModal, EditPermisosUserModal,
		EditUserProjectsModal, CreateTareaModal, TareaModal, CreateEntregaModal, EntregaModal, CreateRDIModal, RDIModal, AcceptCancelModal,
		EditPermisosEmpresaUserModal, CloseOpenProjectModal, CreateAdicionalModal, AdicionalModal, CreateAdicionalLikelyModal, AdicionalLikelyModal,
		AddPlanoModal, CreateProtocoloModal, EditPlanoModal, PlanoTotalViewer, EntregaConfigModal, NotificationsConfigModal, SpecialtySubscriptionModal,
		CreateMeetingModal, MeetingModal, UserComplianceConsentAcceptance, ComplaintModal, CommunicationModal,
		CreateCommunicationFolioModal, CreateCommunicationFolioOpeningModal, CommunicationFolioModal
	},
	computed: {
		complaintModal: {
			get() {
				return this.$store.globalStore.state.complaintModal
			},
			set(value) {
				this.$store.globalStore.commit('setComplaintModal', value)
			}
		},
		communicationModal: {
			get() {
				return this.$store.globalStore.state.communicationModal
			},
			set(value) {
				this.$store.globalStore.commit('setCommunicationModal', value)
			}
		},
		isAdditionalLikely(){
			return this.$store.consultasStore.state.currentTarea && this.$store.consultasStore.state.currentTarea.is_posible_additional
		},
		isTask(){
			return this.$store.consultasStore.state.currentTarea && !this.$store.consultasStore.state.currentTarea.is_posible_additional
		},
		communicationActionDenied(){
			return this.$store.communicationBooksStore.state.actionDenied
		},
		showAcceptanceModal(){
			if(!this.$store.userStore.state.userInfo) return false
			return !this.$store.userStore.state.userInfo?.consent
		}
	},
	data: () => ({
		//
	}),
	watch: {
		communicationActionDenied(denied){
			if(!denied) return
			this.$store.globalStore.dispatch('addMessage', { message: denied.message, title: 'Sin permisos', created: new Date(), type: 'error', icon: 'mdi-alert' })
			this.$store.communicationBooksStore.commit('setActionDenied', null)
		}
	},
	mounted(){
	}
};
</script>
